import { render } from "../views/quick_reply.html?vue&type=template&id=f1c2f7b4&ts=true&external"
import script from "../scripts/quick_reply.ts?vue&type=script&lang=ts&external"
export * from "../scripts/quick_reply.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/quick_reply.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1c2f7b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1c2f7b4', __exports__)) {
    api.reload('f1c2f7b4', __exports__)
  }
  
  module.hot.accept("../views/quick_reply.html?vue&type=template&id=f1c2f7b4&ts=true&external", () => {
    api.rerender('f1c2f7b4', render)
  })

}


export default __exports__